<template>
  <div>
    <div class="titlePdf text-center html2pdf__page-break">
      <p class="font-size-36 text-dark font-weight-semibold" style="font-size: 36px">判定結果</p>
      <div style="text-align: left;font-size: 18px;color: black;margin-top: 300px;margin-left: -100px">
        <p>
          名前 :
          {{ infoPDF && infoPDF.information ? infoPDF.information.fullname : "" }}
        </p>
        <p>ID : {{ infoPDF.patient_id }}</p>

        <p>
          性別 :
          {{
          infoPDF.information && infoPDF.information.sex === 0
          ? "女性"
          : infoPDF.information && infoPDF.information.sex === 1
          ? "男性"
          : "無回答"
          }}
        </p>
        <p>質問 ：ロコモ２５</p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-9">
        <table>
          <tbody
            v-for="(history, indexHis) in locomo25"
            class="html2pdf__page-break"
            :key="indexHis"
          >
            <tr style="cursor: pointer">
              <td style="border-bottom-width: 0">
                <div>
                  <p class="mt-1 text-black" style="font-size: 14px; margin-bottom: 3px">
                    {{ history.created_at | fomatDate2 }}
                  </p>
                  <div class="col-md-12 mb-3">
                    <span style="font-size: 13px">
                      {{ history.current_score }} / {{ history.max_score }}
                      {{ $t("menuitems.hospital.points") }}
                      {{getLevel(history.current_score)}}
                    </span>
                  </div>
                </div>
                <div class="row" style="font-size: 13px">
                  <div
                    class="col-12 text-black"
                    :class="index != 13 ? 'pb-3' : ''"
                    v-for="(question, index) in gQuestions.sub_questions"
                    :key="index"
                  >
                    <h6 class="text-black">
                      {{ index + 1 }} .
                      {{ question ? question.description : "" }}
                    </h6>
                    <span
                      v-for="(answer, i) in question.answers"
                      :key="i"
                      class="form-radio-outline form-radio-success"
                    >
                      <label
                        class="text-black"
                        style="margin-right: 1em"
                        v-if="history.answer.result.findIndex(item => item.id == answer.id) > -1"
                        >➝ {{ answer.value }}
                      </label>
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { filter } from "../../helpers/Vue-Filter";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import {getProfile} from "../../helpers/Auth";

export default {
  filters: {
    ...filter,
  },
  props: ["locomo25", "infoPDF"],
  data() {
    return {
      activeColor: "#8FC31F",
      clickIndex: 0,
      resultAnswer: [],
    };
  },

  created() {
    const me = getProfile();
    this.getQuestionsUser(me.role.name);
  },

  computed: {
    ...hospitalComputed,
  },

  methods: {
    ...hospitalMethods,

    getLevel(data) {
      let text;
      if (data < 7) {
        text = "";
      } else if (data >= 7 && data < 16) {
        text = "（ロコモ度" + 1 + "）";
      } else if (data >= 16 && data < 25) {
        text = "（ロコモ度" + 2 + "）";
      } else {
        text = "（ロコモ度" + 3 + "）";
      }

      return text;
    }
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Noto Sans JP";
}

.text-answers {
  color: #000000;
  font-weight: 700;
  font-size: 12px;
}

.icon-locomo {
  color: #810d20;
}

.color-locomo {
  color: black !important;
  font-size: 18px;
}

.color-level {
  font-weight: 700;
  font-size: 20px;
}

.label-answers {
  color: #d3d3d3;
  font-size: 14px;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.titlePdf {
  margin: auto;
  width: 50%;
  padding: 10px;
  //   height: 100px !important;
  margin-top: 50%;
}

.text-list-locomo-7 {
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 700;
}

* {
  font-family: "Noto Sans JP";
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.bg-active-locomo {
  background: #f8f9fa;
}

.text-end {
  align-items: end;
}

.scroll {
  height: 300px;
  overflow-y: scroll;
}
  .font-size-36 {
    font-size: 36px;
  }
</style>
